import EnTextField from 'Components/inputs/EnTextFieldV2/EnTextFieldV2.vue';
import EnOverlaySpinner from 'Components/feedback/EnOverlaySpinner/EnOverlaySpinner';
import EnWidgetCard from 'Components/widgets/EnWidgetCard/EnWidgetCard.vue';
import EnButton from 'Components/base/EnButton/EnButton.vue';
import { EnButtonVariants } from 'Components/types/EnButtonVariants';
import { getUrlParams } from 'Js/utils/urlUtils';
import { useSessionStorage } from 'Components/navigation/utils/useSessionStorage';
import { required, validEmail } from 'Js/validation/rules';
export default {
  __name: 'forgotPassword',
  setup(__props, _ref) {
    let __expose = _ref.expose;
    __expose();
    const _useSessionStorage = useSessionStorage(),
      getIsEnTab = _useSessionStorage.getIsEnTab;
    const isEnTab = computed(() => {
      return getIsEnTab();
    });
    const returnUrl = ref('');
    const email = ref('');
    const loading = ref(false);
    const emailRules = ref([required, validEmail]);
    const isEmailValid = computed(() => {
      return required(email.value) === true && validEmail(email.value) === true;
    });
    const successRequest = ref(null);
    const titleMessage = computed(() => {
      if (successRequest.value === null) {
        return t('Authentication.password.forgot.title');
      }
      return t('Authentication.password.forgot.successMessage');
    });
    const backToLoginUrl = computed(() => {
      return "/Account/Login".concat(isEnTab.value ? 'EnTab' : '').concat(returnUrl.value ? '?returnUrl=' + encodeURIComponent(returnUrl.value) : '');
    });
    async function sendRequest() {
      loading.value = true;
      const response = await fetch("/api/Manage/ForgotPassword?email=".concat(email.value), {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
      successRequest.value = response.ok;
      loading.value = false;
    }
    onBeforeMount(async () => {
      const params = getUrlParams(window.location);
      returnUrl.value = params['returnurl'];
    });
    const __returned__ = {
      getIsEnTab,
      isEnTab,
      returnUrl,
      email,
      loading,
      emailRules,
      isEmailValid,
      successRequest,
      titleMessage,
      backToLoginUrl,
      sendRequest,
      EnTextField,
      get EnOverlaySpinner() {
        return EnOverlaySpinner;
      },
      EnWidgetCard,
      EnButton,
      get EnButtonVariants() {
        return EnButtonVariants;
      },
      get getUrlParams() {
        return getUrlParams;
      },
      get useSessionStorage() {
        return useSessionStorage;
      },
      get required() {
        return required;
      },
      get validEmail() {
        return validEmail;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};